import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SELECTOR = "p, h1, h2, h3, h4, li, dd, dt, blockquote, figcaption, label, a, span, button, .eyebrow";
const SKIP = new Set(["SCRIPT", "STYLE", "CODE", "PRE", "INPUT", "TEXTAREA"]);
const NBSP = "\u00A0";
const SHORT = /(^|\s)([A-Za-z&]{1,2}|[A-Za-z]{1,3}\.)\s(?=\S)/g;

function smartQuotes(t) {
  return t
    .replace(/(\w)'(\w)/g, "$1\u2019$2")
    .replace(/(^|[\s(\[{\u2014\u2013])'/g, "$1\u2018")
    .replace(/'/g, "\u2019")
    .replace(/(^|[\s(\[{\u2014\u2013])"/g, "$1\u201C")
    .replace(/"/g, "\u201D");
}

function fixNode(node) {
  const t = node.nodeValue;
  if (!t) return;
  let out = /['"]/.test(t) ? smartQuotes(t) : t;
  if (t.trim().length >= 12) {
    out = out.replace(SHORT, `$1$2${NBSP}`);
    const words = out.trim().split(/\s+/);
    if (words.length >= 4) {
      const i = out.lastIndexOf(" ");
      if (i > 0 && out.slice(i + 1).trim().length <= 12) out = out.slice(0, i) + NBSP + out.slice(i + 1);
    }
  }
  if (out !== t) node.nodeValue = out;
}

function guard(root) {
  root.querySelectorAll(SELECTOR).forEach((el) => {
    if (el.closest("[data-no-typeguard]")) return;
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
      acceptNode: (n) => (SKIP.has(n.parentNode?.nodeName) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT),
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(fixNode);
  });
}

export default function TypeGuard() {
  const { pathname } = useLocation();
  useEffect(() => {
    const root = document.getElementById("root");
    if (!root) return;
    let raf = 0;
    const run = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => guard(root));
    };
    run();
    const obs = new MutationObserver(run);
    obs.observe(root, { childList: true, subtree: true });
    return () => {
      obs.disconnect();
      cancelAnimationFrame(raf);
    };
  }, [pathname]);
  return null;
}
